var _g, _path, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 65,
    viewBox: "0 0 196 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1347_33810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.5 51C176.822 51 186 41.8218 186 30.5C186 19.1782 176.822 10 165.5 10C154.178 10 145 19.1782 145 30.5C145 41.8218 154.178 51 165.5 51Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.688 33.375C166.345 33.3735 165.058 32.8397 164.109 31.8906C163.16 30.9415 162.626 29.6547 162.625 28.3125C162.625 27.9224 162.76 27.5442 163.007 27.2424C163.255 26.9407 163.599 26.7339 163.981 26.6573L164.789 28.2745L163.936 29.55L164.052 29.8313C164.455 30.7878 165.216 31.5487 166.172 31.9512L166.454 32.0672L167.731 31.215L169.348 32.0222C169.271 32.4051 169.063 32.7492 168.76 32.9959C168.457 33.2426 168.078 33.3766 167.688 33.375Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.506 22.2682L166.857 22.2984C168.602 22.4923 170.234 23.2745 171.481 24.5211L171.724 24.776C172.908 26.073 173.62 27.737 173.735 29.4967C173.85 31.2564 173.361 32.999 172.355 34.4391L172.147 34.7223C171.073 36.1206 169.557 37.1088 167.851 37.5279L167.507 37.6041C165.815 37.9394 164.064 37.6977 162.529 36.9283L160.307 37.6695C160.032 37.7612 159.737 37.7741 159.455 37.7076H159.454C159.207 37.6493 158.978 37.5316 158.788 37.3658L158.708 37.2916C158.529 37.1119 158.396 36.8916 158.321 36.65L158.292 36.5455C158.226 36.2632 158.239 35.9681 158.331 35.693L158.332 35.691L159.075 33.4723C158.306 31.9378 158.064 30.1879 158.399 28.4957L158.475 28.1519C158.894 26.4465 159.882 24.9302 161.28 23.856L161.564 23.648C163.004 22.6423 164.747 22.1533 166.506 22.2682Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1347_33810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 49C41.8218 49 51 39.8218 51 28.5C51 17.1782 41.8218 8 30.5 8C19.1782 8 10 17.1782 10 28.5C10 39.8218 19.1782 49 30.5 49Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5628 22.1835C33.1257 22.0399 32.623 21.9441 32.1639 21.9441C31.5956 21.9441 30.3716 22.3511 30.3716 23.141V25.0319H33.2787V28.2154H30.3716V37H27.4426V28.2154H26V25.0319H27.4426V23.4282C27.4426 21.0106 28.4481 19 30.8743 19C31.7049 19 33.1913 19.0479 34 19.359L33.5628 22.1835Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1347_33810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5 53C109.926 53 120 42.9264 120 30.5C120 18.0736 109.926 8 97.5 8C85.0736 8 75 18.0736 75 30.5C75 42.9264 85.0736 53 97.5 53Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32.8125C98.5533 32.8125 99.8125 31.5533 99.8125 30C99.8125 28.4467 98.5533 27.1875 97 27.1875C95.4467 27.1875 94.1875 28.4467 94.1875 30C94.1875 31.5533 95.4467 32.8125 97 32.8125Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.375 23.25H93.625C91.761 23.25 90.25 24.761 90.25 26.625V33.375C90.25 35.239 91.761 36.75 93.625 36.75H100.375C102.239 36.75 103.75 35.239 103.75 33.375V26.625C103.75 24.761 102.239 23.25 100.375 23.25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.656 27.1875C101.122 27.1875 101.5 26.8097 101.5 26.3438C101.5 25.8778 101.122 25.5 100.656 25.5C100.19 25.5 99.8125 25.8778 99.8125 26.3438C99.8125 26.8097 100.19 27.1875 100.656 27.1875Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1347_33810",
    x: 135,
    y: 2,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_33810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_33810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1347_33810",
    x: 0,
    y: 0,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_33810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_33810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1347_33810",
    x: 65,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_33810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_33810",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/Social.7473ca2cb5e95d826062c9d0b10e8a94.svg";
export { ForwardRef as ReactComponent };